
import React from 'react';

interface LegalModalProps {
  onAccept: () => void;
  isFirstVisit: boolean;
  onClose: () => void;
}

export const LegalModal: React.FC<LegalModalProps> = ({ onAccept, isFirstVisit, onClose }) => {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/90 backdrop-blur-md p-4 animate-fade-in">
      <div className="bg-slate-800 border border-white/10 w-full max-w-md rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]">
        
        <div className="p-6 border-b border-white/10 flex justify-between items-center">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-indigo-400">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
            </svg>
            Safety & Terms
          </h2>
          {!isFirstVisit && (
            <button onClick={onClose} className="text-slate-400 hover:text-white">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        <div className="p-6 overflow-y-auto custom-scrollbar text-sm text-slate-300 leading-relaxed space-y-4">
          
          <section>
            <h3 className="text-white font-semibold mb-1">⚠️ Physical Safety & Liability</h3>
            <p>
              This application requires physical movement of your device. <strong>Hold your device securely at all times.</strong> 
              Ensure you have adequate space around you and are aware of your surroundings.
            </p>
            <p className="mt-2 text-xs text-slate-400 uppercase tracking-wide border-l-2 border-red-500/50 pl-2">
              The developers are not liable for any damage to your device, personal injury, or property damage resulting from the use of this application.
            </p>
          </section>

          <section className="bg-indigo-900/20 p-3 rounded-lg border border-indigo-500/30">
            <h3 className="text-indigo-300 font-semibold mb-1 flex items-center gap-2">
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                 <path strokeLinecap="round" strokeLinejoin="round" d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.287a6 6 0 0 1 0 7.427M12 6.75v10.5a3.75 3.75 0 1 1-7.5 0V6.75a3.75 3.75 0 1 1 7.5 0Z" />
               </svg>
               iPhone Users Note
            </h3>
            <p className="text-xs text-slate-300">
              If your music isn't playing, please check the <strong>Silent Mode Switch</strong> on the side of your iPhone. Web Audio is often muted when this switch is active.
            </p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-1">👁️ Photosensitivity Warning</h3>
            <p>
              This app produces flashing lights and rapidly changing visual patterns. Discontinue use immediately if you experience discomfort.
            </p>
          </section>

          <section>
            <h3 className="text-white font-semibold mb-1">🔒 Privacy & AI</h3>
            <p>
              <strong>Motion Data:</strong> All accelerometer and gyroscope data is processed locally on your device in real-time.
            </p>
            <p className="mt-2">
              <strong>AI Mindfulness Analysis:</strong> When you choose to analyze a recorded session, anonymous performance metrics (duration, gesture fluidity, intensity, and tempo stability) are sent to Gemini to generate your Flow State Score, somatic reflection, and personalized breathing recommendation.
            </p>
          </section>

        </div>

        <div className="p-6 border-t border-white/10 bg-slate-900/50">
          <button 
            onClick={onAccept}
            className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg font-bold shadow-lg shadow-indigo-500/25 transition active:scale-95"
          >
            {isFirstVisit ? "I Understand & Accept" : "Close"}
          </button>
        </div>

      </div>
    </div>
  );
};
